export default __webpack_public_path__ + "static/media/Wallpaper-5.ba1afa25.jpg";